import { Add, Edit } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Avatar, Chip, Paper, SwipeableDrawer, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';

const validationSchema = yup.object({
  FL_ROLE_NAME: yup.string().required('Role Name is required'),
});

const Role = () => {
  const [roles, setRoles] = useState([]);
  const [drawer, setDrawer] = useState(false);
  const [loading, setLoading] = useState(false);
  const {rights} = useJumboAuth()
  const swal = useSwalWrapper();

  const formik = useFormik({
    initialValues: {
      FL_ROLE_ID: '',
      FL_ROLE_NAME: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      if (values.FL_ROLE_ID) {
        // Update role
        await jwtAuthAxios.post(`roleMenu/editrole/${values.FL_ROLE_ID}`, values)
          .then((response) => {
            if (response.data.status === 'success') {
              fetchRoles();
              setDrawer(false);
              swal.fire({
                icon: 'success',
                text: response.data.message,
              });
            } else {
              swal.fire({
                icon: 'error',
                text: response.data.message,
              });
            }
          })
          .catch((error) => {
            console.error(error);
            swal.fire({
              icon: 'error',
              text: 'Something Went Wrong',
            });
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        // Add role
        await jwtAuthAxios.post('roleMenu/addrole', values)
          .then((response) => {
            if (response.data.status === 'success') {
              fetchRoles();
              setDrawer(false);
              swal.fire({
                icon: 'success',
                text: response.data.message,
              });
            } else {
              swal.fire({
                icon: 'error',
                text: 'Something Went Wrong',
              });
            }
          })
          .catch((error) => {
            console.error(error);
            swal.fire({
              icon: 'error',
              text: 'Something Went Wrong',
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
  });

  useEffect(() => {
    // Fetch roles from the API using jwtAuthAxios
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      setRoles([]);
      const { data } = await jwtAuthAxios.get('roleMenu/roles');
      setRoles(data);
    } catch (error) {
      console.error(error);
      swal.fire({
        icon: 'error',
        text: 'Something Went Wrong',
      });
    }
  };

  const roleEditHandler = (role) => {
    formik.setValues({
      FL_ROLE_ID: role.FL_ROLE_ID || '',
      FL_ROLE_NAME: role.FL_ROLE_NAME || '',
    });
    setDrawer(true);
  };

  const toggleActiveState = async (role) => {
    alert("We cannot modify the role. Please deactivate the user.");
  };

  return (
    <div>
      {rights.insert==1&&<LoadingButton variant="contained" onClick={() => setDrawer(true)} sx={{ display: 'flex', margin: '0 0px 22px auto' }} startIcon={<Add />} color="primary">
        Add Role
      </LoadingButton>}
      {roles && (
        <TableContainer component={Paper}>
          {roles.length > 0 ?<Table  size='small'>
            <TableHead>
              <TableRow>
                <TableCell>Role Name</TableCell>
                <TableCell>Is Active</TableCell>
                <TableCell align='right'>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              { roles.map((role, index) => (
                <TableRow key={index}>
                  <TableCell>{role.FL_ROLE_NAME}</TableCell>
                  <TableCell>
                    <Chip
                      color={role.FL_IS_ACTIVE ? 'success' : 'error'}
                      label={role.FL_IS_ACTIVE ? 'Active' : 'Inactive'}
                      onClick={() => toggleActiveState(role)}
                    />
                  </TableCell>
                  <TableCell align='right'>
                  {rights?.edit ==1 && <Chip
                      color="error"
                      icon={<Edit fontSize='18px' />}
                      label="Edit"
                      onClick={() => roleEditHandler(role)}
                    />}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>:<TableSkeleton cols={3} />}
        </TableContainer>
      )}
      <SwipeableDrawer
        anchor="right"
        open={drawer}
        onClose={() => setDrawer(false)}
        onOpen={() => setDrawer(true)}
      >
        <Box
          component="form"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minWidth: '400px',
            margin: '0 auto',
            p: 3,
          }}
          onSubmit={formik.handleSubmit}
        >
          <h3 style={{ padding: '5px', marginTop: '0' }}>Role</h3>
          <TextField
            label="Role Name"
            variant="outlined"
            margin="normal"
            fullWidth
            autoFocus
            {...formik.getFieldProps('FL_ROLE_NAME')}
            error={formik.touched.FL_ROLE_NAME && Boolean(formik.errors.FL_ROLE_NAME)}
            helperText={formik.touched.FL_ROLE_NAME && formik.errors.FL_ROLE_NAME}
          />
          <LoadingButton
            loading={loading}
            type="submit"
            variant="contained"
            color="primary"
            sx={{ marginTop: '16px' }}
          >
            Submit
          </LoadingButton>
        </Box>
      </SwipeableDrawer>
    </div>
  );
};
Role.Modulename='ROLE';
export default Role;
